import type { PlanQuote, PlanTier } from './types'
export function canChangePlan(quote: PlanQuote | null, selected: PlanTier, current: PlanTier, allowCurrent = false): boolean {
  return (allowCurrent || selected !== current) && quote?.new_plan === selected && quote.current_plan === current && quote.affordable === true
}
